@let items = entities();

@if (certificationAttachee()) {
  <div class="gap-md grid">
    <div class="gap-xxs grid">
      <p class="paragraph-large-semibold">Certification déjà attachée</p>
      <app-card-certification [certification]="certificationAttachee()!" [actions]="certificationAttacheeActions()" />
    </div>
    <p class="text-content-secondary paragraph-medium-medium">
      Pour chercher une autre certification, veuillez d’abord délier la certification rattachée.
    </p>
  </div>
} @else if (!form().disabled) {
  <div class="gap-lg grid">
    <app-input-search (onFilter)="filtres.set($event)" placeholder="Recherchez une certification" />
    <span hlmFieldDescription>Si vous ne trouvez pas votre certification, contactez le support.</span>

    <div class="gap-xs grid">
      @for (item of items; track item.id) {
        <app-card-certification
          class="hover:cursor-pointer"
          [certification]="item"
          [actions]="certificationDetacheeActions()"
          (onClick)="lierCertification(item)"
        />
      } @empty {
        <app-empty-state title="Tapez le nom d'une certification dans la barre de recherche.">
          <span class="paragraph-medium-medium text-content-secondary text-center"
            >Veuillez taper le nom d’une certification présente sur la base de données de
            <a [href]="urlFranceCompetences" hlmBtn variant="link" size="compact" target="_blank">France Compétences</a
            >.</span
          >
        </app-empty-state>
      }
    </div>
  </div>
}
